import { ApiModel } from "./api-model";

export class BTSportPossibleDatetime extends ApiModel {
  isPossible: boolean;
  possibleStartTime: Date;
  possibleEndTime: Date;

  constructor(data: any) {
    super(data);
    this.possibleStartTime = new Date(this.possibleStartTime);
    this.possibleEndTime = new Date(this.possibleEndTime);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/bt-sport-possible-datetime.ts